import React, { useContext, useState } from "react";
import classes from "./BusinessSection.module.scss";
import cs from "classnames";
import { ACTIONS } from "../../../store";
import { StoreContext } from "../../../contexts";
import Loader from "../../atoms/Loader";
import Button, { SIZES } from "../../atoms/Button";
import { isMobile } from "react-device-detect";
import partnersCardMobile from "../../../assets/images/partners-card-mobile.png";
import partnersCard from "../../../assets/images/partners-card.png";
import screenHeights from "../../../assets/images/screen_heights.png";
import BusinessCard from "../../pages/Partners/components/BusinessCard";
import PropTypes from "prop-types";

const BusinessSection = ({ onScrollToPartnersSection, hideBottom = false }) => {
    const { partnership } = useContext(StoreContext);
    const [flippedBusinessCard, setFlippedBusinessCard] = useState(null);

    const handleBusinessCardClick = (index) => {
        if (flippedBusinessCard == index) {
            setFlippedBusinessCard(null);
        } else {
            setFlippedBusinessCard(index);
        }
    };

    return (
        <div className={cs(classes.businessSection, hideBottom && classes.modalVariant)}>
            <div className={cs(classes.businessSectionTop)}>
                <div className={cs(classes.businessSectionTopLeft)}>
                    <div className={cs(classes.businessSectionTopInfo)}>
                        <img
                            className={cs(
                                classes.browserHide,
                                classes.mobileCardImage
                            )}
                            src={partnersCardMobile}
                            alt="partnersCardMobile"
                        />

                        <h1>
                            Get Discounts <span> Everywhere!</span>
                        </h1>
                        <p>
                            As a partner, you&apos;ll receive our ultimate discount
                            card.
                        </p>
                        <p>
                            This exclusive card unlocks incredible partner-only
                            discounts at your{" "}
                            <br className={cs(classes.mobileHide)} /> favorite
                            stores, ensuring you enjoy unparalleled savings and
                            benefits!
                        </p>
                    </div>
                    {/* Desktop: First 4 business cards - hidden on mobile */}
                    <div className={cs(classes.mobileHide)}>
                        {!partnership[
                            `isLoading${ACTIONS.PARTNERSHIP.GET_ALL_BUSINESS_PARTNERS}`
                        ] ? (
                            <>
                                {partnership.businessPartners?.length > 0 && (
                                    <div className={cs(classes.businessCardConatiner)}>
                                        {partnership.businessPartners
                                            .slice(0, 4)
                                            .map((card, index) => {
                                                return (
                                                    <BusinessCard
                                                        key={card.name}
                                                        card={card}
                                                        index={index}
                                                        handleBusinessCardClick={handleBusinessCardClick}
                                                        flippedBusinessCard={flippedBusinessCard}
                                                        setFlippedBusinessCard={setFlippedBusinessCard}
                                                    />
                                                );
                                            })}
                                    </div>
                                )}
                            </>
                        ) : (
                            <Loader />
                        )}
                    </div>
                </div>
                <img
                    src={partnersCard}
                    alt="partnersCard"
                    className={cs(classes.partnersCard, classes.mobileHide)}
                />
            </div>

            {/* Desktop: Remaining business cards (after first 4) - hidden on mobile */}
            <div className={cs(classes.businessCardConatiner)}>
                {!partnership[
                    `isLoading${ACTIONS.PARTNERSHIP.GET_ALL_BUSINESS_PARTNERS}`
                ] ? (
                    <>
                        {partnership.businessPartners?.length > 0 &&
                            partnership.businessPartners.slice(4).map((card, index) => {
                                return (
                                    <BusinessCard
                                        key={card.name}
                                        card={card}
                                        handleBusinessCardClick={handleBusinessCardClick}
                                        flippedBusinessCard={flippedBusinessCard}
                                        setFlippedBusinessCard={setFlippedBusinessCard}
                                        index={index}
                                    />
                                );
                            })}
                    </>
                ) : null}
            </div>

            {/* Mobile: All business cards - hidden on desktop */}
            <div className={cs(classes.businessCardConatiner, classes.browserHide)}>
                {partnership[
                    `isLoading${ACTIONS.PARTNERSHIP.GET_ALL_BUSINESS_PARTNERS}`
                ] ? (
                    <Loader />
                ) : (
                    <>
                        {partnership.businessPartners?.length > 0 &&
                            partnership.businessPartners.map((card, index) => {
                                return (
                                    <BusinessCard
                                        key={card.name}
                                        card={card}
                                        handleBusinessCardClick={handleBusinessCardClick}
                                        flippedBusinessCard={flippedBusinessCard}
                                        setFlippedBusinessCard={setFlippedBusinessCard}
                                        index={index}
                                    />
                                );
                            })}
                    </>
                )}
            </div>
            <div className={cs(classes.termsContainer)}>
                {!hideBottom &&


                    <div className={cs(classes.item, classes.img)}>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://screenheights.com/"
                        >
                            <img src={screenHeights} />
                        </a>
                    </div>}
                <div className={cs(classes.item, classes.text, hideBottom && classes.textFull)}>
                    <p>
                        Terms and conditions apply. Store terms prevail in case of
                        discrepancies. Discounts and offers may change without
                        notice and cannot be combined.
                    </p>
                </div>
            </div>

            {!hideBottom && (
                <div className={cs(classes.businessSectionBottom)}>
                    <div className={cs(classes.businessSectionButtonConatiner)}>
                        {!isMobile && (
                            <Button
                                size={isMobile ? SIZES.STRETCHED : SIZES.M}
                                borderRadiusPixel={30}
                                color="yellow"
                                onClick={() => onScrollToPartnersSection && onScrollToPartnersSection()}
                            >
                                Become a Partner
                            </Button>
                        )}
                        <Button
                            size={isMobile ? SIZES.STRETCHED : SIZES.M}
                            borderRadiusPixel={30}
                            color="brown"
                            onClick={() => {
                                window.open("mailto:info@maorcard.org");
                            }}
                        >
                            MaorCard Customer Service
                        </Button>
                        <Button
                            onClick={() => {
                                window.open(
                                    "https://docs.google.com/forms/d/e/1FAIpQLSfhjWEdClRVjgnwkYyPPGbYhtAnhNauRFrHNFplr0--D1sQkw/viewform"
                                );
                            }}
                            size={isMobile ? SIZES.STRETCHED : SIZES.M}
                            borderRadiusPixel={30}
                            color="yellowGradient"
                        >
                            Business Sign-Up
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BusinessSection;

BusinessSection.propTypes = {
    onScrollToPartnersSection: PropTypes.func,
    hideBottom: PropTypes.bool,
};

BusinessSection.defaultProps = {
    onScrollToPartnersSection: () => { },
    hideBottom: false,
};

